/*
 * pl-reveal.js — reveal-on-scroll + count-up for Plushie.Land.
 * Any element with class `reveal` fades/slides in when it enters the viewport.
 * Any [data-count] inside a revealed element counts up to its target
 * (data-count, optional data-prefix / data-suffix). Respects reduced motion,
 * and re-initialises sections added in the theme editor.
 */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var target = parseInt(el.getAttribute('data-count'), 10) || 0;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    function fmt(n) { return prefix + n.toLocaleString() + suffix; }
    if (reduced) { el.textContent = fmt(target); return; }
    var dur = 1400, start = null;
    function tick(now) {
      if (!start) start = now;
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(Math.round(target * eased));
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function revealNow(el) {
    el.classList.add('in');
    var counts = el.querySelectorAll ? el.querySelectorAll('[data-count]') : [];
    for (var i = 0; i < counts.length; i++) countUp(counts[i]);
  }

  var io = null;
  if ('IntersectionObserver' in window && !reduced) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { revealNow(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
  }

  function observe(root) {
    var els = (root || document).querySelectorAll('.reveal');
    for (var i = 0; i < els.length; i++) {
      if (io) io.observe(els[i]); else revealNow(els[i]);
    }
  }

  observe(document);

  // Theme editor: reveal sections as they are (re)loaded.
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
